// Top navigation + footer — shared chrome for all routes.

const Nav = ({ navItems, pages, route, setRoute, theme }) => {



	return (

		<header className="wi-nav">

			<button className="wi-mark" onClick={() => setRoute("home")}>
				<span hidden className="wi-mark-glyph" aria-hidden>
					{/* Tiny original mark: an island silhouette in negative space */}
					<svg viewBox="0 0 32 32" width="22" height="22">
						<circle cx="16" cy="16" r="15" fill="none" stroke="currentColor" strokeWidth="1" />
						<path
						d="M5 19 Q10 14 14 17 T22 16 Q26 15 27 18"
						fill="none"
						stroke="currentColor"
						strokeWidth="1"
						strokeLinecap="round"
						/>
					</svg>
				</span>
				<span className="wi-mark-text">
					<span className="wi-mark-name">Winter Islands</span>
					<span className="wi-mark-sub" data-insert-html dangerouslySetInnerHTML={{__html: pages.find(p => p.slug === "header-left").description}}></span>
				</span>
			</button>

			<nav className="wi-nav-links">
				{navItems.map((it) => (
					<button
						key={it.id}
						className={`wi-nav-link ${route === it.id ? "is-active" : ""}`}
						onClick={() => setRoute(it.id)}
					>
						{it.label}
					</button>
				))}
			</nav>

			<div className="wi-nav-meta">
				{/*<span className="wi-mono">{theme.toUpperCase()}</span>*/}
				<span hidden className="wi-dot" />
				<span className="wi-mono" data-insert-html dangerouslySetInnerHTML={{__html: pages.find(p => p.slug === "header-right").description}}></span>
			</div>

		</header>
	);
};

export default Nav;
